import { render, staticRenderFns } from "./FilterWallet.vue?vue&type=template&id=ff424fbc&"
import script from "./FilterWallet.vue?vue&type=script&lang=js&"
export * from "./FilterWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilterWallet.vue"
export default component.exports